import { Link } from "react-router-dom";

import type { CSSProperties, FC } from "react";

const wrapperStyle: CSSProperties = {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    background: "linear-gradient(194deg, #f9fbff 0%, #eef4ff 100%)",
    padding: "32px",
    boxSizing: "border-box",
};

const contentStyle: CSSProperties = {
    width: "min(480px, 100%)",
    padding: "48px 40px",
    borderRadius: "24px",
    background: "#ffffff",
    boxShadow: "0 18px 48px rgba(26, 36, 47, 0.12)",
    textAlign: "center",
};

const statusStyle: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    background: "rgba(26, 36, 47, 0.08)",
    color: "#1a242f",
    fontSize: "32px",
    fontWeight: 600,
    marginBottom: "24px",
};

const titleStyle: CSSProperties = {
    margin: "0 0 12px",
    fontSize: "28px",
    fontWeight: 600,
    color: "#1a242f",
};

const descriptionStyle: CSSProperties = {
    margin: 0,
    color: "rgba(26, 36, 47, 0.64)",
    lineHeight: 1.6,
};

const actionsStyle: CSSProperties = {
    marginTop: "28px",
    display: "flex",
    justifyContent: "center",
};

const linkStyle: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px 24px",
    background: "#1a73e8",
    borderRadius: "999px",
    color: "#ffffff",
    fontWeight: 600,
    textDecoration: "none",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
};

export const NotFoundPage: FC = () => (
    <section style={wrapperStyle} aria-labelledby="not-found-title">
        <div style={contentStyle}>
            <span style={statusStyle} aria-hidden>
                404
            </span>
            <h1 id="not-found-title" style={titleStyle}>
                Кажется, такой страницы нет
            </h1>
            <p style={descriptionStyle}>Проверьте адрес или вернитесь на главную страницу, чтобы продолжить.</p>
            <div style={actionsStyle}>
                <Link to="/" style={linkStyle}>
                    На главную
                </Link>
            </div>
        </div>
    </section>
);
